import { useContext } from 'react';
import LoanDetailContext from '../context/loanDetailContext';

/** Loan id from React context, falling back to localStorage when context has not synced yet. */
export default function useLoanId() {
  const { loan_id: contextLoanId } = useContext(LoanDetailContext);
  if (contextLoanId) {
    return contextLoanId;
  }
  return localStorage.getItem('loan_id') || '';
}
